import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import routerME from '@/routes/router-mobile';
import routerPC from '@/routes/router-pc';
import utils from '@/utils/tools';
import { FloatButton } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
const App = () => {
    const routes = utils.isMobile() ? routerME : routerPC;
    const packedRouterConfigs = buildRoutes(routes);
    const router = createBrowserRouter(packedRouterConfigs);
    return (
        <>
            <FloatButton icon={<HomeOutlined />}
                type="default"
                href='/home'
                style={{
                    right: '0.5rem',
                    bottom: '1.3rem',

                }} />
            <RouterProvider router={router} />
        </>
    )
}
const build_page_element = (component) => {
    const KeepedComponent = keep_component(lazy(() => import(`@/pages/${component}`)));
    return <Suspense fallback={<div style={{fontSize:20}}>页面加载中......</div>}>
        <KeepedComponent />
    </Suspense>
}
const keep_component = (Component) => {
    return (props) => {
        return (
            <Component {...props} />
        )
    }

}
const buildRoute = (config) => {
    let route = { ...config }
    if (!!route.redirect) {
        route.element = <Navigate to={route.redirect} replace />
    }

    if (!!route.component) {
        route.element = build_page_element(route.component)
    }

    // build children, current path as parentPath of children routes
    if (!!route.children) {
        route.children = buildRoutes(route.children)
    }
    return route
}
const buildRoutes = (originalRoutes) => {
    const packedRoutes = originalRoutes.map((route) => {
        return buildRoute(route)
    });

    return packedRoutes
}
export default App;